import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPagenation',
  setup(__props) {

const SimplePagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/SimplePagination.vue"))
const DisabledPagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/DisabledPagination.vue"))
const IconsPagenation = defineAsyncComponent(() => import("@/components/theme/advance/pagination/IconsPagenation.vue"))
const ActivePagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/ActivePagination.vue"))
const OutlinePagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/OutlinePagination.vue"))
const RoundedPagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/RoundedPagination.vue"))
const AlignmentsPagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/AlignmentsPagination.vue"))
const SizingPagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/SizingPagination.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      mains: "Pagination",
      title: "Pagination"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(SimplePagination)),
        _createVNode(_unref(DisabledPagination)),
        _createVNode(_unref(IconsPagenation)),
        _createVNode(_unref(ActivePagination)),
        _createVNode(_unref(OutlinePagination)),
        _createVNode(_unref(RoundedPagination)),
        _createVNode(_unref(AlignmentsPagination)),
        _createVNode(_unref(SizingPagination))
      ])
    ])
  ], 64))
}
}

})